import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { BehaviorSubject } from 'rxjs';
import { ActivityCalendarService } from '../activity-calendar-service/activity-calendar.service';
import { ActivityHistoryDetail } from '../activity-calendar-service/activity-history-detail';
import {
  activityHistoryDetailAnimations,
  slideUpDown,
  slideSide,
  collectionAnimation,
} from './activity-history-detail-animations';

@Component({
  selector: 'lp2-activity-history-detail',
  templateUrl: './activity-history-detail.component.html',
  styleUrls: ['./activity-history-detail.component.scss'],
  animations: [activityHistoryDetailAnimations, slideUpDown, slideSide, collectionAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityHistoryDetailComponent implements OnInit {
  @Input() pageSize = 4;
  @Input() date: Date;
  @Output() backToCalendar: EventEmitter<void> = new EventEmitter();

  activityDetails$ = new BehaviorSubject<ActivityHistoryDetail[]>(null);
  displayActivityDetails$ = new BehaviorSubject<ActivityHistoryDetail[]>(null);
  currentPage = 1;
  totalPages = 1;
  loadedPages = 0;

  constructor(
    private readonly activityCalendarService: ActivityCalendarService,
    private readonly oeAppPersonService: OeAppPersonService
  ) {}

  ngOnInit() {
    if (!this.date) {
      return;
    }
    const personId = this.oeAppPersonService.id;
    this.activityCalendarService.getActivityDetailByDate(this.date, personId).subscribe((response) => {
      this.activityDetails$.next(response);
      this.pageChanged();
    });
  }

  getCollectionSize() {
    if (!this.activityDetails$.value) {
      return 0;
    }
    return this.activityDetails$.value.length;
  }

  goBack() {
    this.backToCalendar.emit();
  }

  pageChanged() {
    if (!this.activityDetails$.value) {
      return;
    }
    this.displayActivityDetails$.next([]);
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.displayActivityDetails$.next(this.activityDetails$.value.slice(startIndex, endIndex));
    this.loadedPages = this.loadedPages + 1;
  }
}



// WEBPACK FOOTER //
// ./ts/app/activity-calendar/activity-history-detail/activity-history-detail.component.ts